import React from 'react'

const ManagementPage = () => {
  return (
    <div>ManagementPage</div>
  )
}

export default ManagementPage